<template>
  <div style="padding: 10px;" v-if="config">
    <v-row>
      <preview-popup
        v-if="selectedPreviewData"
        :data="selectedPreviewData"
        :locale="selectedPreviewData.locale"
        :onClose="() => { selectedPreviewData = null }"
        :config="config"
      />
      <v-col
        cols="12"
        sm="12"
        md="7"
        style="padding: 10px;"
      >
        <div
          style="background-color: white;padding-bottom: 100px"
        >
          <v-toolbar dense elevation="0">
            <v-toolbar-title>
              Mensaje de bienvenida
            </v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="popups"
            class="elevation-0 custom-table"
            hide-default-footer
            :loading="loading"
            :expanded.sync="expanded"
            show-expand
            item-key="ID"
            :items-per-page="itemsPerPage"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="background-color: #CCCCCC;">
                <stats-view
                  :id="item.ID"
                />
              </td>
            </template>
            <template v-slot:[`item.ident`]="{ item }">
              <a class="ident" @click="handleEdit(item.ID)">{{item.Name || item.ID}}</a>
            </template>
            <template v-slot:[`item.preview`]="{ item }">
              <a
                v-for="l of languages"
                :key="l"
                class="ident" 
                @click="handlePreview(item, l)"
                style="padding-right: 10px;"
              >{{l}}</a>
            </template>
            <template v-slot:[`item.cd-lmd`]="{ item }">
              <b>CD: </b>{{prepareDatetime(item.CD)}}<br/>
              <b>LMD: </b>{{prepareDatetime(item.LMD)}}<br/>
            </template>
            <template v-slot:no-data>        
              <v-alert
                v-show="!loading"
                border="bottom"
                color="primary"
                style="margin-top:20px"
                outlined
                dense
              >
                <v-btn
                  @click="handleEdit(null)"
                  style="margin-left: 20px;"
                >
                {{ $t('common.newItem', locale) }}
                </v-btn>
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="5"
        style="padding: 10px 10px 0 0;"
      >
        <div
          style="background-color: white;padding: 10px;min-height: 100px;"
        >
          <popup-form
            :editedItem="editedItem"
            :onClose="handleClose"
            :onAdd="() => { handleEdit(null)}"
            :locale="locale"
            :languages="languages"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
const defaultItem = {
  Message: { es: '' },
  BGColor: 'white',
  Color: 'black',
  WithButton: false,
  ButtonText: { es: '' },
  ButtonLink: { es: '' },
}
import { mapState } from 'vuex'
import apiDtouch from '@/services/apiDtouch'
import PopupForm from './PopupForm'
import PreviewPopup from './PreviewPopup'
import StatsView from './StatsView'
export default {
  components: {
    PopupForm,
    PreviewPopup,
    StatsView,
  },
  data: () => ({
    loading: false,
    config: null,
    expanded: [],
    popups: [],
    editedItem: null,
    languages: [],
    selectedPreviewData: null,
  }),
  computed: {
    ...mapState('app',['locale', 'dtouchWorkspace']),
    itemsPerPage () {
      return 10000
    },
    headers () {
      return [
          {
            text: 'Nombre',
            align: 'start',
            sortable: false,
            value: 'ident',
          },
          { text: 'Preview', value: 'preview', sortable: false },
          { text: '', value: 'cd-lmd', sortable: false },
          { text: '', value: 'data-table-expand' },
        ]
    },
  },
  watch: {
    dtouchWorkspace () {
      this.editedItem = null
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    prepareDatetime (v) {
      if (!v) return v
      return v.split('T').join(' ').split('.').shift()
    },
    async handleGetData () {
      try {
        this.popups = []
        this.loading = true
        this.config = await new Promise((resolve, reject) => apiDtouch.getItem(`v1/public/workspaces/${this.dtouchWorkspace}`)
          .then(response => {
            if (!response) {
              resolve({
                Languages: [ 'es', 'en' ]
              })
              return
            }
            response.Languages = response.Languages ? response.Languages.split(',') : [ 'es', 'en' ]
            resolve(response)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
          .finally(() => {
          }))
        this.languages = this.config.Languages

        apiDtouch.getAll(`v1/private/workspaces/${this.dtouchWorkspace}/pop-up`)
          .then(response => {
            if (!response) return
            this.popups = response
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.loading = false
          })
      } catch (error) {
        console.log(error)
        
      }
    },
    handleClose (refresh) {
      if (refresh) {
        this.handleGetData()
      }
      this.editedItem = null
    },
    async handleEdit (v) {
      try {
        if (!v) {
          const aux = JSON.parse(JSON.stringify(defaultItem))
          aux.WorkspaceID = this.dtouchWorkspace
          aux.tmpImage = aux.Image
          this.editedItem = aux
          return
        }
        this.loading = true
        if (v) {
          this.editedItem = await new Promise((resolve, reject) => apiDtouch.getAll(`v1/private/pop-up/${v}`)
          .then(response => {
            response.WorkspaceID = this.dtouchWorkspace
            response.tmpImage = response.Image
            if (!response.Availability || !response.Availability.IsTemp) {
              response.Availability =  null
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            this.loading = false
          }))
        }
      } catch (error) {
        console.log(error)
      }
    },
    handlePreview (v, locale) {
      const aux = v
      aux.locale = locale
      this.selectedPreviewData = aux
      console.log(v, locale)
    },
  },
}
</script>

